import { querySharedServices } from '@/src/domains/shared/services';
import { queryEntityCostPage } from '@/src/views/EntityCost/services';

export { EntityCost as default } from '@/src/views/EntityCost';

export async function getStaticProps({ previewData, locale }) {
  const data = await queryEntityCostPage({ previewData, locale });

  if (!data) {
    return { notFound: true };
  }

  const sharedServices = await querySharedServices({ previewData, locale });

  return {
    props: {
      ...data,
      sharedServices,
    },
  };
}
